/**
 * Route for `advanced-retargeting-controls-for-smarter-compliance`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvancedRetargetingControlsForSmarterCompliancePage } from "../features/advanced-retargeting-controls-for-smarter-compliance/AdvancedRetargetingControlsForSmarterCompliancePage";

export const advancedRetargetingControlsForSmarterComplianceRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advanced-retargeting-controls-for-smarter-compliance",
	component: AdvancedRetargetingControlsForSmarterCompliancePage,
});

export default advancedRetargetingControlsForSmarterComplianceRoute;
